"use client";

import React from "react";
import UserPicture from "@/app/(components)/generics/UserPicture/UserPicture";
import styles from "./EntityDetail.module.css";

/* ── Sub-components ─────────────────────────────────── */

type DetailRowProps = {
  label: string;
  value: React.ReactNode;
  muted?: boolean;
};

export function DetailRow({ label, value, muted = false }: DetailRowProps) {
  return (
    <div className={styles.row}>
      <span className={styles.label}>{label}</span>
      <span className={muted ? styles.valueMuted : styles.value}>{value}</span>
    </div>
  );
}

export function DetailGrid({ children }: { children: React.ReactNode }) {
  return <div className={styles.grid}>{children}</div>;
}

/* ── Main component ─────────────────────────────────── */

export type DetailSection = {
  title?: string;
  content: React.ReactNode;
};

type HeaderProps = {
  initials: string;
  name: string;
  subHeader?: React.ReactNode;
};

export function EntityDetailHeader({ initials, name, subHeader }: HeaderProps) {
  return (
    <div className={styles.header}>
      <div className={styles.avatar}>
        <UserPicture className={styles.avatarLetter} displayLetter={initials} />
      </div>
      <p className={styles.name}>{name}</p>
      {subHeader}
    </div>
  );
}

type Props = {
  initials: string;
  name: string;
  subHeader?: React.ReactNode;
  sections: DetailSection[];
  actions?: React.ReactNode;
  hideHeader?: boolean;
};

export default function EntityDetail({
  initials,
  name,
  subHeader,
  sections,
  actions,
  hideHeader,
}: Props) {
  return (
    <div className={styles.content}>
      {!hideHeader && <EntityDetailHeader initials={initials} name={name} subHeader={subHeader} />}

      {sections.map((section, i) => (
        <div key={i} className={styles.section}>
          {section.title && <p className={styles.sectionTitle}>{section.title}</p>}
          {section.content}
        </div>
      ))}

      {actions && <div className={styles.actions}>{actions}</div>}
    </div>
  );
}
